import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  TextField,
} from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { makeStyles } from '@material-ui/core/styles';

import { debounce, fuzzyMatch } from '../../../utils/functions';

import './AddGameModal.scss';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    borderRadius: '5px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));


const pingTwitchGames = (searchValue, headers, setAllGames, originalSearchValue) => {
  // For very short searches, search for first few characters to get broader results
  const apiSearchTerm = searchValue.length <= 3 ? searchValue.substring(0, 1) : searchValue.trim();

  axios
    .get(`/api/v1/admin/game/search/${apiSearchTerm}`, headers)
    .then((resp) => {
      setAllGames({ games: resp.data.games, searchTerm: originalSearchValue });
    })
    .catch(err => console.error(err));
};

const debouncePingingTwitchGames = debounce(pingTwitchGames, 1000);

const AddGameModal = (props) => {
  const classes = useStyles();

  const { handleAddSelectedGame, token, values } = props;

  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [availableGames, setAvailableGames] = useState([]);
  const [allGames, setAllGames] = useState({ games: [], searchTerm: '' }); // Store all games from API
  const [isLoading, setIsLoading] = useState(false);


  const headers = { headers: { Authorization: `JWT ${token}` } };

  useEffect(() => {
    if (searchValue && searchValue.length >= 3) {
      setIsLoading(true);
      // Fetch broader results from API (debounced)
      debouncePingingTwitchGames(searchValue, headers, (data) => {
        setAllGames(data);
        setIsLoading(false);
      }, searchValue);
    } else {
      setAvailableGames([]);
      setAllGames({ games: [], searchTerm: '' });
      setIsLoading(false);
    }
  }, [searchValue]);

  // Apply client-side fuzzy filtering when we have games
  useEffect(() => {
    if (searchValue && allGames.games.length > 0) {
      // Apply fuzzy filtering on the cached games
      const filtered = allGames.games.filter(game => fuzzyMatch(searchValue, game)).sort();
      setAvailableGames(filtered);
    } else if (!searchValue) {
      setAvailableGames([]);
    }
  }, [searchValue, allGames]);


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSearchValue('');
    setAvailableGames([]);
    setAllGames({ games: [], searchTerm: '' });
    setIsLoading(false);
    setOpen(false);
  };

  const handleGameClick = (game) => {
    handleAddSelectedGame(game);
    setAvailableGames(availableGames.filter(g => g !== game));
  };

  const handleTextChange = (e) => {
    setSearchValue(e.target.value);
  };

  const renderAvailableGames = availableGames.filter(g => !values.includes(g)).map(g => (
    <ListItem key={g} id={g} button onClick={() => handleGameClick(g)}>
      <ListItemIcon>
        <AddBoxIcon />
      </ListItemIcon>
      <ListItemText primary={g} />
    </ListItem>
  ));

  const AddModal = (
    <div id="AddModal" style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">Add{values && values.length ? ' More' : ''} Required Games</h2>
      <div id="simple-modal-description" className="AddGameModal--list">
        <Paper style={{ height: 200, overflow: 'auto' }}>
          <List>
            {isLoading ? (
              <ListItem>
                <ListItemText primary={`Searching for "${searchValue}"...`} />
              </ListItem>
            ) : renderAvailableGames.length > 0 ? (
              <>
                <ListItem disabled>
                  <ListItemText
                    primary={`Search for: ${searchValue}`}
                    primaryTypographyProps={{ style: { fontWeight: 'bold', fontSize: '0.9rem' } }}
                  />
                </ListItem>
                {renderAvailableGames}
              </>
            ) : searchValue.length >= 3 ? (
              <ListItem>
                <ListItemText primary="No games found" />
              </ListItem>
            ) : null}
          </List>
        </Paper>
      </div>
      <TextField
        className="AddGameModal--textfield"
        label="Game Name"
        onChange={handleTextChange}
        value={searchValue}
        variant="filled"
      />
      <Button onClick={handleClose} className="AddGameModal--close">
        Close
      </Button>
    </div>
  );

  return (
    <div className="AddGameModal">
      <Button variant="contained" onClick={handleOpen} color="primary" className="AddGameModal--button">
        Add More Required Games
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {AddModal}
      </Modal>
    </div>
  );
};

export default AddGameModal;
